<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Dropzone from "@/components/c-dropzone";
import Loading from "@/components/c-loading";
import i18n from "../../../../i18n";
// import { servicehelpers } from "../../../../services/servicehelpers";
import { projectService } from "../../../../services/projectservice/project.service";
// import { settingService } from "../../../../services/settingservice/setting.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Project",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    Dropzone
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Project",
      breadCrumb: {},

      project: {},
      projectOwnerDataList: {},
      valueCode: '',
      valueName: '',
      valueNameEn: '',
      valuePhone1: '',
      valuePhone2: '',
      valueAddress: '',
      valueAddressEn: '',
      valueProjectOwner: 0, 
      valueLogo: [],
      valueLatitude: 0,
      valueLongitude: 0,
      valueAttachment: '',
      valueGem: 0,
      valuePool: 0,
      valueSkybar: 0,
      valueOther: 0,
      valueParking: 0,

    };
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      projectService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.project = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          this.valueCode = this.project.code;
          this.valueName = this.project.name;
          this.valueNameEn = this.project.name_en;
          this.valuePhone1 = this.project.phone_no_1;
          this.valuePhone2 = this.project.phone_no_2;
          this.valueAddress = this.project.address;
          this.valueAddressEn = this.project.address_en;
          this.valueProjectOwner = this.project.project_owner_id;
          this.valueLogo.push(this.project.logo);
          this.valueLatitude = this.project.latitude;
          this.valueLongitude = this.project.longitude;
          this.valueAttachment = '';
          this.valueGem = this.project.gem_floor;
          this.valuePool = this.project.pool_floor;
          this.valueSkybar = this.project.skybar_floor;
          this.valueOther = this.project.other_floor;
          this.valueParking = this.project.parking_floor;


        });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-project"
          });

        }
      });
      
    },

    submitSave: function() {

      this.tryingToSubmit = true;

      let project = {
        code: this.valueCode,
        name: this.valueName,
        name_en: this.valueNameEn,
        phone_no_1: this.valuePhone1,
        phone_no_2: this.valuePhone2,
        address: this.valueAddress,
        address_en: this.valueAddressEn,
        project_owner_id: this.valueProjectOwner,
        logo: this.valueLogo[0],
        latitude: this.valueLatitude,
        longitude: this.valueLongitude,
        attachment: this.valueAttachment,
        gem_floor: this.valueGem,
        pool_floor: this.valuePool,
        skybar_floor: this.valueSkybar,
        other_floor: this.valueOther,
        parking_floor: this.valueParking
      };

      // console.log(JSON.stringify(project));

      if(this.isAdd) {
        projectService.insert(project)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "setting-project"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        projectService.update(this.$route.params.id, project)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-project"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {
      this.valueCode = '';
      this.valueName = '';
      this.valueNameEn = '';
      this.valuePhone1 = '';
      this.valuePhone2 = '';
      this.valueAddress = '';
      this.valueAddressEn = '';
      this.valueProjectOwner = 0;
      this.valueLogo = [''];
      this.valueLatitude = 0;
      this.valueLongitude = 0;
      this.valueAttachment = '';
      this.valueGem = 0;
      this.valuePool = 0;
      this.valueSkybar = 0;
      this.valueOther = 0;
      this.valueParking = 0;
    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('project.text'),
        href: '/setting/property/project',
      }, {
        text: $t('project.new'),
        active: true
      }]" :title="this.isAdd ? $t('project.new') : $t('project.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('project.text'),
        href: '/setting/property/project',
      }, this.breadCrumb]" :title="this.isAdd ? $t('project.new') : $t('project.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />


    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <Input 
                  :type="'text'"
                  :id="'code'"
                  :disabled="true"
                  v-model="dataCode"
                  :label="'customer.code'"
                    /> 
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :label="'project.name'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'text'"
                    :id="'name_en'"
                    v-model="valueNameEn"
                    :label="'project.name-en'"  />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <Input 
                  :type="'text'"
                  :id="'phone_no_1'"
                  v-model="valuePhone1"
                  :mask="'### ### ########'"
                  :require="true"
                  :label="'project.phone-no-1'"  />
              </div>
              <div class="col-md-6">
                <Input 
                  :type="'text'"
                  :id="'phone_no_2'"
                  :mask="'### ### ########'"
                  v-model="valuePhone2"
                  :label="'project.phone-no-2'"  />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'latitude'"
                    v-model="valueLatitude"
                    :label="'project.latitude'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'longitude'"
                    v-model="valueLongitude"
                    :label="'project.longitude'"  />
              </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="5"
                    :id="'address'"
                    v-model="valueAddress"
                    :label="'project.address'"  />
                </div>
                <div class="col-lg-12">
                  <Area 
                    :rows="5"
                    :id="'address_en'"
                    v-model="valueAddressEn"
                    :label="'project.address-en'"  />
                </div>
              </div>
            
            <div class="row">
              <div inline class="row gy-2 gx-3 align-items-end">
                <div class="col-sm-auto">
                  <Button v-bind:icon="'bx bx-x-circle'" 
                    v-bind:buttonType="'button'"
                    v-bind:variant="'danger'"
                    @click="submitCancel()"
                    v-bind:title="$t('general.cancel')"  />
                </div>
                <div class="col-sm-auto">
                  <Button v-bind:icon="'bx bx-save bx-tada'" 
                    v-bind:buttonType="'button'"
                    @click="submitSave()"
                    v-bind:requesting="tryingToSubmit"
                    v-bind:title="$t('general.save')"  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <Dropzone 
                  :id="'logo'"
                  :maxFiles="1"
                  :label="'project.logo'" 
                  :preview="valueLogo[0]"
                  @uploadSuccess="uploadPhotoSuccess" />
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'parking_floor'"
                    :last="'project.floor'"
                    v-model="valueParking"
                    :label="'project.parking'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'skybar_floor'"
                    :last="'project.floor'"
                    v-model="valueSkybar"
                    :label="'project.skybar'"  />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'gem_floor'"
                    :last="'project.floor'"
                    v-model="valueGem"
                    :label="'project.gem'"  />
              </div>
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'pool_floor'"
                    :last="'project.floor'"
                    v-model="valuePool"
                    :label="'project.pool'"  />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'other_floor'"
                    :last="'project.floor'"
                    v-model="valueGem"
                    :label="'project.other'"  />
              </div>
            </div>
          </div>
        </div>

      </div>
    </b-form> 

  </Layout>
</template>